export default __webpack_public_path__ + "static/media/Message.aba3875d.svg";